/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { ChangeEvent, useState } from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { get } from "lodash";
import { connect } from "react-redux";
import { useFormikContext } from "formik";
import { Data } from "../../../../../store/terminal/types";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";
import OptionalToolTip from "../../../../../common/toolTip/OptionalToolTip";

interface ConfigurationProps {
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

interface ConfigurationHocProps {
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const ConfigurationMerchantChoice = (props: ConfigurationHocProps) => {
  // const maximumNumber = 999999.99;
  const { isUpdateAllowed, shouldHideField } = props;
  const formikProps = useFormikContext();
  const values = (formikProps.values as unknown) as Data;
  const touched = (formikProps.touched as unknown) as Data;
  const errors = (formikProps.errors as unknown) as Data;
  const { setFieldValue, setFieldTouched } = formikProps;

  const centToDollar = (cents: number) => {
    return (cents / 100).toFixed(2).toString(); // convert cents to dollars and round to 2 decimal places
  };

  const [dollarValues, setDollarValues] = useState({
    MCRMinAmount:
      values.attributes.MCRMinAmount ||
      Number(values.attributes.MCRMinAmount) == 0
        ? // @ts-ignore
          centToDollar(values.attributes.MCRMinAmount)
        : "",
    MastercardMCRThreshold:
      values.attributes.MastercardMCRThreshold ||
      Number(values.attributes.MastercardMCRThreshold) == 0
        ? // @ts-ignore
          centToDollar(values.attributes.MastercardMCRThreshold)
        : "",
    VisaMCRThreshold:
      values.attributes.VisaMCRThreshold ||
      Number(values.attributes.VisaMCRThreshold) == 0
        ? // @ts-ignore
          centToDollar(values.attributes.VisaMCRThreshold)
        : "",
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    const fieldName = event.target.name;
    const key = fieldName.replace("attributes.", ""); // Remove the 'attributes.' prefix

    setFieldTouched(fieldName, true);

    setDollarValues((prevState) => ({
      ...prevState,
      [key]: input,
    }));

    const inputInCents = Math.round(parseFloat(input) * 100);
    const fieldValue = isNaN(inputInCents) ? "" : inputInCents;
    setFieldValue(fieldName, fieldValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} alignItems="center" md={4}>
        <OptionalToolTip
          tooltip={get(
            props,
            `toolTips.terminals.options.configuration.["MCRThreshold"]`
          )}
        >
          <TextField
            type="number"
            name="attributes.MCRMinAmount"
            variant="outlined"
            label="MCR THRESHOLD"
            fullWidth
            // @ts-ignore
            value={dollarValues["MCRMinAmount"]}
            onChange={handleChange}
            error={
              !!(
                touched.attributes &&
                touched.attributes.MCRMinAmount &&
                errors.attributes &&
                errors.attributes.MCRMinAmount
              )
            }
            helperText={
              touched.attributes &&
              touched.attributes.MCRMinAmount &&
              errors.attributes &&
              errors.attributes.MCRMinAmount
                ? errors.attributes.MCRMinAmount
                : ""
            }
            InputProps={{
              endAdornment: <InputAdornment position="end">$</InputAdornment>,
            }}
            disabled={!isUpdateAllowed}
          />
        </OptionalToolTip>
      </Grid>
      <Grid item xs={12} alignItems="center" md={4}>
        <OptionalToolTip
          tooltip={get(
            props,
            `toolTips.terminals.options.configuration.["MCRMastercardThreshold"]`
          )}
        >
          <TextField
            type="number"
            name="attributes.MastercardMCRThreshold"
            variant="outlined"
            label="MCR MASTERCARD THRESHOLD"
            fullWidth
            // @ts-ignore
            value={dollarValues["MastercardMCRThreshold"]}
            onChange={handleChange}
            error={
              !!(
                touched.attributes &&
                touched.attributes.MastercardMCRThreshold &&
                errors.attributes &&
                errors.attributes.MastercardMCRThreshold
              )
            }
            helperText={
              touched.attributes &&
              touched.attributes.MastercardMCRThreshold &&
              errors.attributes &&
              errors.attributes.MastercardMCRThreshold
                ? errors.attributes.MastercardMCRThreshold
                : ""
            }
            InputProps={{
              endAdornment: <InputAdornment position="end">$</InputAdornment>,
            }}
          />
        </OptionalToolTip>
      </Grid>
      <Grid item xs={12} alignItems="center" md={4}>
        <OptionalToolTip
          tooltip={get(
            props,
            `toolTips.terminals.options.configuration.["MCRVisaThreshold"]`
          )}
        >
          <TextField
            type="number"
            name="attributes.VisaMCRThreshold"
            variant="outlined"
            label="MCR VISA THRESHOLD"
            fullWidth
            // @ts-ignore
            value={dollarValues["VisaMCRThreshold"]}
            onChange={handleChange}
            error={
              !!(
                touched.attributes &&
                touched.attributes.VisaMCRThreshold &&
                errors.attributes &&
                errors.attributes.VisaMCRThreshold
              )
            }
            helperText={
              touched.attributes &&
              touched.attributes.VisaMCRThreshold &&
              errors.attributes &&
              errors.attributes.VisaMCRThreshold
                ? errors.attributes.VisaMCRThreshold
                : ""
            }
            InputProps={{
              endAdornment: <InputAdornment position="end">$</InputAdornment>,
            }}
          />
        </OptionalToolTip>
      </Grid>
    </Grid>
  );
};

const ConnectedConfigurationMerchantChoice = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: ConfigurationHocProps) => {
    return {
      ...ownProps,
      shouldHideField: ownProps.shouldHideField,
    };
  }
)(ConfigurationMerchantChoice);

const ConnectedConfigurationMerchantChoiceHoc = (props: ConfigurationProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedConfigurationMerchantChoice {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedConfigurationMerchantChoiceHoc;
